import { FilesGateway } from './files-gateway.interface';
import * as FileSaver from 'file-saver';

const baseUrl = 'gk/documents';
export class HttpFilesGateway implements FilesGateway {
  getDocumentBlobById(args: { documentId: string }) {
    return { url: `${baseUrl}/${args.documentId}/download`, method: 'GET' };
  }

  download(args: { documentId: string; fileName: string; fileMimeType: any }) {
    // return this.getDocumentBlobById({ documentId: args.documentId }).then(
    //   (resp: any) => {
    //     return new Promise((resolve, reject) => {
    //       const extension = args.fileMimeType.split('/')[1];
    //       const realFileName = args.fileName.endsWith(`.${extension}`)
    //         ? args.fileName
    //         : `${args.fileName}.${extension}`;
    //       try {
    //         FileSaver.saveAs(resp.data, realFileName);
    //       } catch (e) {
    //         reject(e);
    //       }
    //     });
    //   }
    // );
    // return { url: `${baseUrl}/`, method: 'GET' };
  }

  getDocumentBlobByProjectAndSlug(args: { projectId: string; slug: string }) {
    return {
      url: `${baseUrl}/download/slug/${args.projectId}/${args.slug}`,
      method: 'GET',
    };
  }

  downloadDocumentBySlug(args: {
    projectId: string;
    slug: string;
    fileName: string;
    fileMimeType: any;
  }) {
    /**
     * TODODEV : trouver une solution ici
     */

    return { url: `${baseUrl}`, method: 'GET' };
  }

  getThumbnail(args: { documentId: string }) {
    return {
      url: `${baseUrl}/${args.documentId}/download-thumbnail`,
      method: 'GET',
    };
  }

  generateFile(args: { projectId: string; standardSlug: string; data?: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/generate/${args.standardSlug}`,
      method: 'POST',
      data: args.data,
      responseType: 'blob',
    };
  }

  getTempAmendementFile(args: { projectId: string; editableConfig: any }) {
    return {
      url: `gk/configurations/upsells/${args.projectId}/get-temp-amendement-file`,
      method: 'POST',
      data: { editableConfig: args.editableConfig },
    };
  }

  /**
   * MODULE CONFIGURATION
   */
  generateQuoteDocumentAndGetFile(args: {
    projectId: string | number;
    configurations: any;
  }) {
    return {
      url: `gk/configurations/${args.projectId}/generate-quote-document`,
      method: 'POST',
      data: { configurations: args.configurations },
    };
  }

  getQuoteFileFromMainConfig(args: { projectId: string | number }) {
    return {
      url: `gk/configurations/${args.projectId}/get-quote-file-from-main-config`,
      method: 'GET',
    };
  }

  /**
   * MODULE CATALOGUE
   */
  downloadIfc(args: { reference: string }) {
    return { url: `gk/catalogue/bim/${args.reference}/file`, method: 'GET' };
  }
}
